// What an upload actually read, in the owner's words. The importer now
// resolves columns by meaning (backend/csv_columns.py), so the screen says
// which column it took each field from — a wrong guess is visible at once
// instead of surfacing weeks later as a strange number.

interface UploadMapping {
  date?: string | null;
  item?: string | null;
  amount?: string | null;
}

interface UploadResult {
  records: number;
  skipped?: number;
  excluded?: number;
  mapping?: UploadMapping;
  // Set by the server when the file does not look like item-level sales
  // (backend/engine/sales_shape.py): imported, but no advice runs on it.
  fits_item_sales?: boolean;
  notice?: string | null;
}

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

export function describeUpload(res: UploadResult): { headline: string; detail: string; notice?: string } {
  const parts = [`Imported ${plural(res.records, 'sale', 'sales')}`];
  if (res.excluded) parts.push(`${res.excluded} failed, refunded or voided left out`);
  if (res.skipped) parts.push(`${plural(res.skipped, 'row', 'rows')} with unreadable dates skipped`);

  const m = res.mapping;
  const fields: [string, string | null | undefined][] = m
    ? [['Dates', m.date], ['items', m.item], ['amounts', m.amount]]
    : [];
  const read = fields.filter(([, col]) => col).map(([label, col]) => `${label} from “${col}”`);
  const summary = { headline: parts.join(' · '), detail: read.length ? `${read.join(', ')}.` : '' };
  return res.notice ? { ...summary, notice: res.notice } : summary;
}
